import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthRedirectService } from './auth-redirect.service';

function hasTokenInUrl(stateUrl: string, routeToken: string | null): boolean {
  if (routeToken) {
    return true;
  }

  try {
    const parsed = new URL(stateUrl, globalThis.location.origin);
    return parsed.searchParams.has('token');
  } catch {
    return stateUrl.includes('token=');
  }
}

export const returnUrlGuard: CanActivateFn = (route, state) => {
  const authRedirectService = inject(AuthRedirectService);
  const router = inject(Router);
  const token = route.queryParamMap?.get('token') ?? null;

  if (hasTokenInUrl(state.url, token)) {
    // Clear stale returnUrl state but keep token-driven navigation in place.
    authRedirectService.consume();
    return true;
  }

  const returnUrl = authRedirectService.consume();
  if (returnUrl) return router.parseUrl(returnUrl);
  return true;
};
